var un = Object.defineProperty;
var cn = (e, t, n) => t in e ? un(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ve = (e, t, n) => (cn(e, typeof t != "symbol" ? t + "" : t, n), n);
import { jsx as ie, jsxs as Ye } from "react/jsx-runtime";
import { z as G } from "zod";
import { withManagedProps as an } from "@made-people/managed-props";
import { withZod as ln } from "@made-people/react-prop-guard";
import { rangeBlueprint as dn } from "./index-blueprint.es.js";
import * as i from "react";
import { createElement as It } from "react";
import * as fn from "react-dom";
import "@made-people/blueprint";
function Mt() {
  return typeof window < "u";
}
function Ot(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ke(e) {
  return Mt() ? e instanceof Element || e instanceof Ot(e).Element : !1;
}
function mn(e) {
  return !Mt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ot(e).ShadowRoot;
}
function Te(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function pn({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = i.useRef(e !== void 0), [s, u] = i.useState(t), l = o ? e : s;
  if (process.env.NODE_ENV !== "production") {
    i.useEffect(() => {
      o !== (e !== void 0) && console.error([`Base UI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: h
    } = i.useRef(t);
    i.useEffect(() => {
      !o && JSON.stringify(h) !== JSON.stringify(t) && console.error([`Base UI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const m = i.useCallback((h) => {
    o || u(h);
  }, []);
  return [l, m];
}
const Et = {};
function Me(e, t) {
  const n = i.useRef(Et);
  return n.current === Et && (n.current = e(t)), n;
}
const it = i[`useInsertionEffect${Math.random().toFixed(1)}`.slice(0, -3)], hn = (
  // React 17 doesn't have useInsertionEffect.
  it && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
  it !== i.useLayoutEffect ? it : (e) => e()
);
function T(e) {
  const t = Me(bn).current;
  return t.next = e, hn(t.effect), t.trampoline;
}
function bn() {
  const e = {
    next: void 0,
    callback: gn,
    trampoline: (...t) => {
      var n;
      return (n = e.callback) == null ? void 0 : n.call(e, ...t);
    },
    effect: () => {
      e.callback = e.next;
    }
  };
  return e;
}
function gn() {
  if (process.env.NODE_ENV !== "production")
    throw new Error("Base UI: Cannot call an event handler while rendering.");
}
const yn = () => {
}, W = typeof document < "u" ? i.useLayoutEffect : yn;
function Vt(e) {
  const t = Me(vn, e).current;
  return t.next = e, W(t.effect), t;
}
function vn(e) {
  const t = {
    current: e,
    next: e,
    effect: () => {
      t.current = t.next;
    }
  };
  return t;
}
let ut;
process.env.NODE_ENV !== "production" && (ut = /* @__PURE__ */ new Set());
function In(...e) {
  if (process.env.NODE_ENV !== "production") {
    const t = e.join(" ");
    ut.has(t) || (ut.add(t), console.warn(`Base UI: ${t}`));
  }
}
function fe() {
}
const Ie = Object.freeze({}), En = "none", Rt = "track-press", Rn = "input-change", Nn = "keyboard", Cn = "drag";
function Fe(e, t, n, r) {
  let o = !1, s = !1;
  const u = r ?? Ie;
  return {
    reason: e,
    event: t ?? new Event("base-ui"),
    cancel() {
      o = !0;
    },
    allowPropagation() {
      s = !0;
    },
    get isCanceled() {
      return o;
    },
    get isPropagationAllowed() {
      return s;
    },
    trigger: n,
    ...u
  };
}
function Tt(e, t, n) {
  const r = n ?? Ie;
  return {
    reason: e,
    event: t ?? new Event("base-ui"),
    ...r
  };
}
function wn(e, t) {
  const n = i.useRef(e), r = T(t);
  W(() => {
    n.current !== e && r(n.current);
  }, [e, r]), W(() => {
    n.current = e;
  }, [e]);
}
const Sn = {
  ...i
};
let Nt = 0;
function xn(e, t = "mui") {
  const [n, r] = i.useState(e), o = e || n;
  return i.useEffect(() => {
    n == null && (Nt += 1, r(`${t}-${Nt}`));
  }, [n, t]), o;
}
const Ct = Sn.useId;
function Pn(e, t) {
  if (Ct !== void 0) {
    const n = Ct();
    return e ?? (t ? `${t}-${n}` : n);
  }
  return xn(e, t);
}
function He(e) {
  return Pn(e, "base-ui");
}
function mt(e, ...t) {
  const n = new URL(`https://base-ui.com/production-error/${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Base UI error #${e}; visit ${n} for the full message.`;
}
function ct(e, t, n, r) {
  const o = Me(Dt).current;
  return Mn(o, e, t, n, r) && Ft(o, [e, t, n, r]), o.callback;
}
function An(e) {
  const t = Me(Dt).current;
  return On(t, e) && Ft(t, e), t.callback;
}
function Dt() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function Mn(e, t, n, r, o) {
  return e.refs[0] !== t || e.refs[1] !== n || e.refs[2] !== r || e.refs[3] !== o;
}
function On(e, t) {
  return e.refs.length !== t.length || e.refs.some((n, r) => n !== t[r]);
}
function Ft(e, t) {
  if (e.refs = t, t.every((n) => n == null)) {
    e.callback = null;
    return;
  }
  e.callback = (n) => {
    if (e.cleanup && (e.cleanup(), e.cleanup = null), n != null) {
      const r = Array(t.length).fill(null);
      for (let o = 0; o < t.length; o += 1) {
        const s = t[o];
        if (s != null)
          switch (typeof s) {
            case "function": {
              const u = s(n);
              typeof u == "function" && (r[o] = u);
              break;
            }
            case "object": {
              s.current = n;
              break;
            }
          }
      }
      e.cleanup = () => {
        for (let o = 0; o < t.length; o += 1) {
          const s = t[o];
          if (s != null)
            switch (typeof s) {
              case "function": {
                const u = r[o];
                typeof u == "function" ? u() : s(null);
                break;
              }
              case "object": {
                s.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const Vn = parseInt(i.version, 10);
function Tn(e) {
  return Vn >= e;
}
function wt(e) {
  if (!/* @__PURE__ */ i.isValidElement(e))
    return null;
  const t = e, n = t.props;
  return (Tn(19) ? n == null ? void 0 : n.ref : t.ref) ?? null;
}
function at(e, t) {
  if (e && !t)
    return e;
  if (!e && t)
    return t;
  if (e || t)
    return {
      ...e,
      ...t
    };
}
function Dn(e, t) {
  const n = {};
  for (const r in e) {
    const o = e[r];
    if (t != null && t.hasOwnProperty(r)) {
      const s = t[r](o);
      s != null && Object.assign(n, s);
      continue;
    }
    o === !0 ? n[`data-${r.toLowerCase()}`] = "" : o && (n[`data-${r.toLowerCase()}`] = o.toString());
  }
  return n;
}
function Fn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function kn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
const ke = {};
function kt(e, t, n, r, o) {
  let s = {
    ...lt(e, ke)
  };
  return t && (s = De(s, t)), n && (s = De(s, n)), r && (s = De(s, r)), o && (s = De(s, o)), s;
}
function Ln(e) {
  if (e.length === 0)
    return ke;
  if (e.length === 1)
    return lt(e[0], ke);
  let t = {
    ...lt(e[0], ke)
  };
  for (let n = 1; n < e.length; n += 1)
    t = De(t, e[n]);
  return t;
}
function De(e, t) {
  return Lt(t) ? t(e) : _n(e, t);
}
function _n(e, t) {
  if (!t)
    return e;
  for (const n in t) {
    const r = t[n];
    switch (n) {
      case "style": {
        e[n] = at(e.style, r);
        break;
      }
      case "className": {
        e[n] = _t(e.className, r);
        break;
      }
      default:
        Bn(n, r) ? e[n] = $n(e[n], r) : e[n] = r;
    }
  }
  return e;
}
function Bn(e, t) {
  const n = e.charCodeAt(0), r = e.charCodeAt(1), o = e.charCodeAt(2);
  return n === 111 && r === 110 && o >= 65 && o <= 90 && (typeof t == "function" || typeof t > "u");
}
function Lt(e) {
  return typeof e == "function";
}
function lt(e, t) {
  return Lt(e) ? e(t) : e ?? ke;
}
function $n(e, t) {
  return t ? e ? (n) => {
    if (zn(n)) {
      const o = n;
      Un(o);
      const s = t(o);
      return o.baseUIHandlerPrevented || e == null || e(o), s;
    }
    const r = t(n);
    return e == null || e(n), r;
  } : t : e;
}
function Un(e) {
  return e.preventBaseUIHandler = () => {
    e.baseUIHandlerPrevented = !0;
  }, e;
}
function _t(e, t) {
  return t ? e ? t + " " + e : t : e;
}
function zn(e) {
  return e != null && typeof e == "object" && "nativeEvent" in e;
}
function Le(e, t, n = {}) {
  const r = t.render, o = qn(t, n);
  if (n.enabled === !1)
    return null;
  const s = n.state ?? Ie;
  return Wn(e, r, o, s);
}
function qn(e, t = {}) {
  const {
    className: n,
    style: r,
    render: o
  } = e, {
    state: s = Ie,
    ref: u,
    props: l,
    stateAttributesMapping: m,
    enabled: h = !0
  } = t, p = h ? Fn(n, s) : void 0, N = h ? kn(r, s) : void 0, b = h ? Dn(s, m) : Ie, c = h ? at(b, Array.isArray(l) ? Ln(l) : l) ?? Ie : Ie;
  return typeof document < "u" && (h ? Array.isArray(u) ? c.ref = An([c.ref, wt(o), ...u]) : c.ref = ct(c.ref, wt(o), u) : ct(null, null)), h ? (p !== void 0 && (c.className = _t(c.className, p)), N !== void 0 && (c.style = at(c.style, N)), c) : Ie;
}
function Wn(e, t, n, r) {
  if (t) {
    if (typeof t == "function")
      return t(n, r);
    const o = kt(n, t.props);
    return o.ref = n.ref, /* @__PURE__ */ i.cloneElement(t, o);
  }
  if (e && typeof e == "string")
    return jn(e, n);
  throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: Render element or function are not defined." : mt(8));
}
function jn(e, t) {
  return e === "button" ? /* @__PURE__ */ It("button", {
    type: "button",
    ...t,
    key: t.key
  }) : e === "img" ? /* @__PURE__ */ It("img", {
    alt: "",
    ...t,
    key: t.key
  }) : /* @__PURE__ */ i.createElement(e, t);
}
function me(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function Bt(e, t, n = (r, o) => r === o) {
  return e.length === t.length && e.every((r, o) => n(r, t[o]));
}
function $t(e) {
  var n;
  let t = e.activeElement;
  for (; ((n = t == null ? void 0 : t.shadowRoot) == null ? void 0 : n.activeElement) != null; )
    t = t.shadowRoot.activeElement;
  return t;
}
function Yn(e, t) {
  var r;
  if (!e || !t)
    return !1;
  const n = (r = t.getRootNode) == null ? void 0 : r.call(t);
  if (e.contains(t))
    return !0;
  if (n && mn(n)) {
    let o = t;
    for (; o; ) {
      if (e === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
const pt = /* @__PURE__ */ i.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  elementsRef: {
    current: []
  },
  nextIndexRef: {
    current: 0
  }
});
process.env.NODE_ENV !== "production" && (pt.displayName = "CompositeListContext");
function Kn() {
  return i.useContext(pt);
}
function Gn(e) {
  const {
    children: t,
    elementsRef: n,
    labelsRef: r,
    onMapChange: o
  } = e, s = T(o), u = i.useRef(0), l = Me(Jn).current, m = Me(Hn).current, [h, p] = i.useState(0), N = i.useRef(h), b = T((f, g) => {
    m.set(f, g ?? null), N.current += 1, p(N.current);
  }), c = T((f) => {
    m.delete(f), N.current += 1, p(N.current);
  }), a = i.useMemo(() => {
    const f = /* @__PURE__ */ new Map();
    return Array.from(m.keys()).filter((I) => I.isConnected).sort(Xn).forEach((I, j) => {
      const D = m.get(I) ?? {};
      f.set(I, {
        ...D,
        index: j
      });
    }), f;
  }, [m, h]);
  W(() => {
    if (typeof MutationObserver != "function" || a.size === 0)
      return;
    const f = new MutationObserver((g) => {
      const I = /* @__PURE__ */ new Set(), j = (D) => I.has(D) ? I.delete(D) : I.add(D);
      g.forEach((D) => {
        D.removedNodes.forEach(j), D.addedNodes.forEach(j);
      }), I.size === 0 && (N.current += 1, p(N.current));
    });
    return a.forEach((g, I) => {
      I.parentElement && f.observe(I.parentElement, {
        childList: !0
      });
    }), () => {
      f.disconnect();
    };
  }, [a]), W(() => {
    N.current === h && (n.current.length !== a.size && (n.current.length = a.size), r && r.current.length !== a.size && (r.current.length = a.size), u.current = a.size), s(a);
  }, [s, a, n, r, h]), W(() => () => {
    n.current = [];
  }, [n]), W(() => () => {
    r && (r.current = []);
  }, [r]);
  const R = T((f) => (l.add(f), () => {
    l.delete(f);
  }));
  W(() => {
    l.forEach((f) => f(a));
  }, [l, a]);
  const w = i.useMemo(() => ({
    register: b,
    unregister: c,
    subscribeMapChange: R,
    elementsRef: n,
    labelsRef: r,
    nextIndexRef: u
  }), [b, c, R, n, r, u]);
  return /* @__PURE__ */ ie(pt.Provider, {
    value: w,
    children: t
  });
}
function Hn() {
  return /* @__PURE__ */ new Map();
}
function Jn() {
  return /* @__PURE__ */ new Set();
}
function Xn(e, t) {
  const n = e.compareDocumentPosition(t);
  return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
function Zn(e, t) {
  return {
    ...e,
    state: {
      ...e.state,
      valid: !t && e.state.valid
    }
  };
}
const Ut = /* @__PURE__ */ i.createContext({
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  clearErrors: fe,
  validationMode: "onSubmit",
  submitAttemptedRef: {
    current: !1
  }
});
process.env.NODE_ENV !== "production" && (Ut.displayName = "FormContext");
function zt() {
  return i.useContext(Ut);
}
const Qn = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: null,
  valueMissing: !1
}, qt = /* @__PURE__ */ i.createContext({
  invalid: void 0,
  name: void 0,
  validityData: {
    state: Qn,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: fe,
  disabled: void 0,
  touched: !1,
  setTouched: fe,
  dirty: !1,
  setDirty: fe,
  filled: !1,
  setFilled: fe,
  focused: !1,
  setFocused: fe,
  validate: () => null,
  validationMode: "onSubmit",
  validationDebounceTime: 0,
  shouldValidateOnChange: () => !1,
  state: {
    disabled: !1,
    valid: null,
    touched: !1,
    dirty: !1,
    filled: !1,
    focused: !1
  },
  markedDirtyRef: {
    current: !1
  },
  validation: {
    getValidationProps: (e = Ie) => e,
    getInputValidationProps: (e = Ie) => e,
    inputRef: {
      current: null
    },
    commit: async () => {
    }
  }
});
process.env.NODE_ENV !== "production" && (qt.displayName = "FieldRootContext");
function ht(e = !0) {
  const t = i.useContext(qt);
  if (t.setValidityData === fe && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>." : mt(28));
  return t;
}
function er(e) {
  const {
    enabled: t = !0,
    value: n,
    id: r,
    name: o,
    controlRef: s,
    commit: u
  } = e, {
    formRef: l
  } = zt(), {
    invalid: m,
    markedDirtyRef: h,
    validityData: p,
    setValidityData: N
  } = ht(), b = T(e.getValue);
  W(() => {
    if (!t)
      return;
    let c = n;
    c === void 0 && (c = b()), p.initialValue === null && c !== null && N((a) => ({
      ...a,
      initialValue: c
    }));
  }, [t, N, n, p.initialValue, b]), W(() => {
    !t || !r || l.current.fields.set(r, {
      getValue: b,
      name: o,
      controlRef: s,
      validityData: Zn(p, m),
      validate() {
        let c = n;
        c === void 0 && (c = b()), h.current = !0, fn.flushSync(() => u(c));
      }
    });
  }, [u, s, t, l, b, r, m, h, o, p, n]), W(() => {
    const c = l.current.fields;
    return () => {
      r && c.delete(r);
    };
  }, [l, r]);
}
const Wt = /* @__PURE__ */ i.createContext({
  controlId: void 0,
  setControlId: fe,
  labelId: void 0,
  setLabelId: fe,
  messageIds: [],
  setMessageIds: fe,
  getDescriptionProps: (e) => e
});
process.env.NODE_ENV !== "production" && (Wt.displayName = "LabelableContext");
function jt() {
  return i.useContext(Wt);
}
function Yt(e, t) {
  return e - t;
}
function tr(e, t, n) {
  const r = e.slice();
  return r[t] = n, r.sort(Yt);
}
function Kt(e, t, n, r, o, s) {
  let u = e;
  return u = me(u, n, r), o && (u = tr(
    s,
    t,
    // Bound the new value to the thumb's neighbours.
    me(u, s[t - 1] || -1 / 0, s[t + 1] || 1 / 0)
  )), u;
}
function Gt(e, t, n) {
  if (!Array.isArray(e))
    return !0;
  const r = e.reduce((o, s, u, l) => (u === l.length - 1 || o.push(Math.abs(s - l[u + 1])), o), []);
  return Math.min(...r) >= t * n;
}
const _e = {
  activeThumbIndex: () => null,
  max: () => null,
  min: () => null,
  minStepsBetweenValues: () => null,
  step: () => null,
  values: () => null
}, bt = /* @__PURE__ */ i.createContext(void 0);
process.env.NODE_ENV !== "production" && (bt.displayName = "SliderRootContext");
function Je() {
  const e = i.useContext(bt);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SliderRootContext is missing. Slider parts must be placed within <Slider.Root>." : mt(62));
  return e;
}
function nr(e) {
  return "key" in e ? Nn : Rn;
}
function rr(e, t) {
  return typeof e == "number" && typeof t == "number" ? e === t : Array.isArray(e) && Array.isArray(t) ? Bt(e, t) : !1;
}
const Ht = /* @__PURE__ */ i.forwardRef(function(t, n) {
  const {
    "aria-labelledby": r,
    className: o,
    defaultValue: s,
    disabled: u = !1,
    id: l,
    format: m,
    largeStep: h = 10,
    locale: p,
    render: N,
    max: b = 100,
    min: c = 0,
    minStepsBetweenValues: a = 0,
    name: R,
    onValueChange: w,
    onValueCommitted: f,
    orientation: g = "horizontal",
    step: I = 1,
    thumbCollisionBehavior: j = "push",
    thumbAlignment: D = "center",
    value: ue,
    ...we
  } = t, pe = He(l), H = T(w), he = T(f), {
    clearErrors: Y
  } = zt(), {
    state: K,
    disabled: J,
    name: A,
    setTouched: X,
    setDirty: F,
    validityData: x,
    shouldValidateOnChange: O,
    validation: $
  } = ht(), {
    labelId: ce
  } = jt(), ee = r ?? ce, Z = J || u, be = A ?? R, [M, Se] = pn({
    controlled: ue,
    default: s ?? c,
    name: "Slider"
  }), ae = i.useRef(null), Ee = i.useRef(null), L = i.useRef([]), _ = i.useRef(null), ge = i.useRef(null), Ne = i.useRef(-1), U = i.useRef(null), z = i.useRef(null), le = i.useRef("none"), d = Vt(m), [E, y] = i.useState(-1), [C, v] = i.useState(-1), [B, ye] = i.useState(!1), [te, Re] = i.useState(() => /* @__PURE__ */ new Map()), [Oe, xe] = i.useState([void 0, void 0]), P = T((S) => {
    y(S), S !== -1 && v(S);
  });
  er({
    id: pe,
    commit: $.commit,
    value: M,
    controlRef: Ee,
    name: be,
    getValue: () => M
  }), wn(M, () => {
    Y(be), O() ? $.commit(M) : $.commit(M, !0);
    const S = x.initialValue;
    let oe;
    Array.isArray(M) && Array.isArray(S) ? oe = !Bt(M, S) : oe = M !== S, F(oe);
  });
  const Pe = T((S) => {
    S && (Ee.current = S);
  }), ne = Array.isArray(M), re = i.useMemo(() => ne ? M.slice().sort(Yt) : [me(M, c, b)], [b, c, ne, M]), Q = T((S, oe) => {
    if (Number.isNaN(S) || rr(S, M))
      return;
    const de = oe ?? Fe(En, void 0, void 0, {
      activeThumbIndex: -1
    });
    le.current = de.reason;
    const Ce = new event.constructor(event.type, event);
    Object.defineProperty(Ce, "target", {
      writable: !0,
      value: {
        value: S,
        name: be
      }
    }), de.event = Ce, z.current = S, H(S, de), !de.isCanceled && Se(S);
  }), Ae = T((S, oe, de) => {
    const Ce = Kt(S, oe, c, b, ne, re);
    if (Gt(Ce, I, a)) {
      const $e = nr(de);
      Q(Ce, Fe($e, de.nativeEvent, void 0, {
        activeThumbIndex: oe
      })), X(!0);
      const vt = z.current ?? Ce;
      he(vt, Tt($e, de.nativeEvent));
    }
  });
  process.env.NODE_ENV !== "production" && c >= b && In("Slider `max` must be greater than `min`."), W(() => {
    var oe;
    const S = $t(Te(ae.current));
    Z && S && ((oe = ae.current) != null && oe.contains(S)) && S.blur();
  }, [Z]), Z && E !== -1 && P(-1);
  const se = i.useMemo(() => ({
    ...K,
    activeThumbIndex: E,
    disabled: Z,
    dragging: B,
    orientation: g,
    max: b,
    min: c,
    minStepsBetweenValues: a,
    step: I,
    values: re
  }), [K, E, Z, B, b, c, a, g, I, re]), rt = i.useMemo(() => ({
    active: E,
    controlRef: Ee,
    disabled: Z,
    dragging: B,
    validation: $,
    formatOptionsRef: d,
    handleInputChange: Ae,
    indicatorPosition: Oe,
    inset: D !== "center",
    labelId: ee,
    largeStep: h,
    lastUsedThumbIndex: C,
    lastChangedValueRef: z,
    lastChangeReasonRef: le,
    locale: p,
    max: b,
    min: c,
    minStepsBetweenValues: a,
    name: be,
    onValueCommitted: he,
    orientation: g,
    pressedInputRef: _,
    pressedThumbCenterOffsetRef: ge,
    pressedThumbIndexRef: Ne,
    pressedValuesRef: U,
    registerFieldControlRef: Pe,
    renderBeforeHydration: D === "edge",
    setActive: P,
    setDragging: ye,
    setIndicatorPosition: xe,
    setValue: Q,
    state: se,
    step: I,
    thumbCollisionBehavior: j,
    thumbMap: te,
    thumbRefs: L,
    values: re
  }), [E, Ee, ee, Z, B, $, d, Ae, Oe, h, C, z, le, p, b, c, a, be, he, g, _, ge, Ne, U, Pe, P, ye, xe, Q, se, I, j, D, te, L, re]), Be = Le("div", t, {
    state: se,
    ref: [n, ae],
    props: [{
      "aria-labelledby": ee,
      id: pe,
      role: "group"
    }, $.getValidationProps, we],
    stateAttributesMapping: _e
  });
  return /* @__PURE__ */ ie(bt.Provider, {
    value: rt,
    children: /* @__PURE__ */ ie(Gn, {
      elementsRef: L,
      onMapChange: Re,
      children: Be
    })
  });
});
process.env.NODE_ENV !== "production" && (Ht.displayName = "SliderRoot");
const St = /* @__PURE__ */ new Map();
function or(e, t) {
  const n = JSON.stringify({
    locale: e,
    options: t
  }), r = St.get(n);
  if (r)
    return r;
  const o = new Intl.NumberFormat(e, t);
  return St.set(n, o), o;
}
function Ge(e, t, n) {
  return e == null ? "" : or(t, n).format(e);
}
const sr = [];
function gt(e) {
  i.useEffect(e, sr);
}
const qe = null;
let xt = globalThis.requestAnimationFrame;
class ir {
  constructor() {
    /* This implementation uses an array as a backing data-structure for frame callbacks.
     * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
     * never calls the native `cancelAnimationFrame` if there are no frames left. This can
     * be much more efficient if there is a call pattern that alterns as
     * "request-cancel-request-cancel-…".
     * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
     * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
    ve(this, "callbacks", []);
    ve(this, "callbacksCount", 0);
    ve(this, "nextId", 1);
    ve(this, "startId", 1);
    ve(this, "isScheduled", !1);
    ve(this, "tick", (t) => {
      var o;
      this.isScheduled = !1;
      const n = this.callbacks, r = this.callbacksCount;
      if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, r > 0)
        for (let s = 0; s < n.length; s += 1)
          (o = n[s]) == null || o.call(n, t);
    });
  }
  request(t) {
    const n = this.nextId;
    this.nextId += 1, this.callbacks.push(t), this.callbacksCount += 1;
    const r = process.env.NODE_ENV === "test" && xt !== requestAnimationFrame && (xt = requestAnimationFrame, !0);
    return (!this.isScheduled || r) && (requestAnimationFrame(this.tick), this.isScheduled = !0), n;
  }
  cancel(t) {
    const n = t - this.startId;
    n < 0 || n >= this.callbacks.length || (this.callbacks[n] = null, this.callbacksCount -= 1);
  }
}
const We = new ir();
class yt {
  constructor() {
    ve(this, "currentId", qe);
    ve(this, "cancel", () => {
      this.currentId !== qe && (We.cancel(this.currentId), this.currentId = qe);
    });
    ve(this, "disposeEffect", () => this.cancel);
  }
  static create() {
    return new yt();
  }
  static request(t) {
    return We.request(t);
  }
  static cancel(t) {
    return We.cancel(t);
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(t) {
    this.cancel(), this.currentId = We.request(() => {
      this.currentId = qe, t();
    });
  }
}
function ur() {
  const e = Me(yt.create).current;
  return gt(e.disposeEffect), e;
}
const Jt = /* @__PURE__ */ i.createContext(void 0);
process.env.NODE_ENV !== "production" && (Jt.displayName = "DirectionContext");
function Xt() {
  const e = i.useContext(Jt);
  return (e == null ? void 0 : e.direction) ?? "ltr";
}
function Zt(e) {
  const t = e.getBoundingClientRect();
  return {
    x: (t.left + t.right) / 2,
    y: (t.top + t.bottom) / 2
  };
}
function cr(e) {
  if (Math.abs(e) < 1) {
    const n = e.toExponential().split("e-"), r = n[0].split(".")[1];
    return (r ? r.length : 0) + parseInt(n[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function Qt(e, t, n) {
  const r = Math.round((e - n) / t) * t + n;
  return Number(r.toFixed(cr(t)));
}
function Pt({
  values: e,
  index: t,
  nextValue: n,
  min: r,
  max: o,
  step: s,
  minStepsBetweenValues: u,
  initialValues: l
}) {
  if (e.length === 0)
    return [];
  const m = e.slice(), h = s * u, p = m.length - 1, N = l ?? e, b = r + t * h, c = o - (p - t) * h;
  m[t] = me(n, b, c);
  for (let a = t + 1; a <= p; a += 1) {
    const R = m[a - 1] + h, w = o - (p - a) * h, f = N[a] ?? m[a];
    let g = Math.max(m[a], R);
    f < g && (g = Math.max(f, R)), m[a] = me(g, R, w);
  }
  for (let a = t - 1; a >= 0; a -= 1) {
    const R = m[a + 1] - h, w = r + a * h, f = N[a] ?? m[a];
    let g = Math.min(m[a], R);
    f > g && (g = Math.min(f, R)), m[a] = me(g, w, R);
  }
  for (let a = 0; a <= p; a += 1)
    m[a] = Number(m[a].toFixed(12));
  return m;
}
function ar({
  behavior: e,
  values: t,
  currentValues: n,
  initialValues: r,
  pressedIndex: o,
  nextValue: s,
  min: u,
  max: l,
  step: m,
  minStepsBetweenValues: h
}) {
  const p = n ?? t, N = r ?? t;
  if (!(p.length > 1))
    return {
      value: s,
      thumbIndex: 0,
      didSwap: !1
    };
  const c = m * h;
  switch (e) {
    case "swap": {
      const a = p[o], R = 1e-7, w = p.slice(), f = w[o - 1], g = w[o + 1], I = f != null ? f + c : u, j = g != null ? g - c : l, D = me(s, I, j), ue = Number(D.toFixed(12));
      w[o] = ue;
      const we = s > a, pe = s < a, H = we && g != null && s >= g - R, he = pe && f != null && s <= f + R;
      if (!H && !he)
        return {
          value: w,
          thumbIndex: o,
          didSwap: !1
        };
      const Y = H ? o + 1 : o - 1, K = w.map((F, x) => {
        if (x === o)
          return ue;
        const O = N[x];
        return O ?? p[x];
      });
      let J = s;
      H ? J = Math.max(s, w[Y]) : J = Math.min(s, w[Y]);
      const A = Pt({
        values: w,
        index: Y,
        nextValue: J,
        min: u,
        max: l,
        step: m,
        minStepsBetweenValues: h,
        initialValues: K
      }), X = H ? Y - 1 : Y + 1;
      if (X >= 0 && X < A.length) {
        const F = A[X - 1], x = A[X + 1];
        let O = F != null ? F + c : u;
        O = Math.max(O, u + X * c);
        let $ = x != null ? x - c : l;
        $ = Math.min($, l - (A.length - 1 - X) * c);
        const ce = me(ue, O, $);
        A[X] = Number(ce.toFixed(12));
      }
      return {
        value: A,
        thumbIndex: Y,
        didSwap: !0
      };
    }
    case "push":
      return {
        value: Pt({
          values: p,
          index: o,
          nextValue: s,
          min: u,
          max: l,
          step: m,
          minStepsBetweenValues: h
        }),
        thumbIndex: o,
        didSwap: !1
      };
    case "none":
    default: {
      const a = p.slice(), R = a[o - 1], w = a[o + 1], f = R != null ? R + c : u, g = w != null ? w - c : l, I = me(s, f, g);
      return a[o] = Number(I.toFixed(12)), {
        value: a,
        thumbIndex: o,
        didSwap: !1
      };
    }
  }
}
const lr = 2;
function dr(e, t) {
  if (!e)
    return {
      start: 0,
      end: 0
    };
  function n(s) {
    const u = s != null ? parseFloat(s) : 0;
    return Number.isNaN(u) ? 0 : u;
  }
  const r = t ? "Top" : "InlineStart", o = t ? "Bottom" : "InlineEnd";
  return {
    start: n(e[`border${r}Width`]) + n(e[`padding${r}`]),
    end: n(e[`border${o}Width`]) + n(e[`padding${o}`])
  };
}
function je(e, t) {
  if (t.current != null && e.changedTouches) {
    const n = e;
    for (let r = 0; r < n.changedTouches.length; r += 1) {
      const o = n.changedTouches[r];
      if (o.identifier === t.current)
        return {
          x: o.clientX,
          y: o.clientY
        };
    }
    return null;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
const en = /* @__PURE__ */ i.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    ...s
  } = t, {
    disabled: u,
    dragging: l,
    validation: m,
    inset: h,
    lastChangedValueRef: p,
    lastChangeReasonRef: N,
    max: b,
    min: c,
    minStepsBetweenValues: a,
    onValueCommitted: R,
    orientation: w,
    pressedInputRef: f,
    pressedThumbCenterOffsetRef: g,
    pressedThumbIndexRef: I,
    pressedValuesRef: j,
    registerFieldControlRef: D,
    renderBeforeHydration: ue,
    setActive: we,
    setDragging: pe,
    setValue: H,
    state: he,
    step: Y,
    thumbCollisionBehavior: K,
    thumbRefs: J,
    values: A
  } = Je(), X = Xt(), F = A.length > 1, x = w === "vertical", O = i.useRef(null), $ = i.useRef(null), ce = T((d) => {
    d && $.current == null && $.current == null && ($.current = getComputedStyle(d));
  }), ee = i.useRef(null), Z = i.useRef(0), be = i.useRef(0), M = Vt(A), Se = T((d) => {
    I.current !== d && (I.current = d);
    const E = J.current[d];
    if (!E) {
      g.current = null, f.current = null;
      return;
    }
    f.current = E.querySelector('input[type="range"]');
  }), ae = T((d) => {
    const E = O.current;
    if (!E)
      return null;
    const {
      width: y,
      height: C,
      bottom: v,
      left: B,
      right: ye
    } = E.getBoundingClientRect(), te = dr($.current, x), Re = be.current, Oe = (x ? C : y) - te.start - te.end - Re * 2, xe = g.current ?? 0, P = d.x - xe, Pe = d.y - xe, ne = x ? v - Pe - te.end : (X === "rtl" ? ye - P : P - B) - te.start, re = me((ne - Re) / Oe, 0, 1);
    let Q = (b - c) * re + c;
    if (Q = Qt(Q, Y, c), Q = me(Q, c, b), !F)
      return {
        value: Q,
        thumbIndex: 0,
        didSwap: !1
      };
    const Ae = I.current;
    if (Ae < 0)
      return null;
    const se = ar({
      behavior: K,
      values: A,
      currentValues: M.current ?? A,
      initialValues: j.current,
      pressedIndex: Ae,
      nextValue: Q,
      min: c,
      max: b,
      step: Y,
      minStepsBetweenValues: a
    });
    return K === "swap" && se.didSwap ? Se(se.thumbIndex) : I.current = se.thumbIndex, se;
  }), Ee = T((d) => {
    j.current = F ? A.slice() : null, M.current = A;
    const E = I.current;
    let y = E;
    if (E > -1 && E < A.length) {
      if (A[E] === b) {
        let C = E;
        for (; C > 0 && A[C - 1] === b; )
          C -= 1;
        y = C;
      }
    } else {
      const C = x ? "y" : "x";
      let v;
      y = -1;
      for (let B = 0; B < J.current.length; B += 1) {
        const ye = J.current[B];
        if (Ke(ye)) {
          const te = Zt(ye), Re = Math.abs(d[C] - te[C]);
          (v === void 0 || Re <= v) && (y = B, v = Re);
        }
      }
    }
    if (y > -1 && y !== E && Se(y), h) {
      const C = J.current[y];
      if (Ke(C)) {
        const v = C.getBoundingClientRect(), B = x ? "height" : "width";
        be.current = v[B] / 2;
      }
    }
  }), L = T((d) => {
    var E, y, C;
    (C = (y = (E = J.current) == null ? void 0 : E[d]) == null ? void 0 : y.querySelector('input[type="range"]')) == null || C.focus({
      preventScroll: !0
    });
  }), _ = T((d) => {
    const E = je(d, ee);
    if (E == null)
      return;
    if (Z.current += 1, d.type === "pointermove" && d.buttons === 0) {
      ge(d);
      return;
    }
    const y = ae(E);
    y != null && Gt(y.value, Y, a) && (!l && Z.current > lr && pe(!0), H(y.value, Fe(Cn, d, void 0, {
      activeThumbIndex: y.thumbIndex
    })), M.current = Array.isArray(y.value) ? y.value : [y.value], y.didSwap && L(y.thumbIndex));
  });
  function ge(d) {
    var C, v;
    we(-1), pe(!1), f.current = null, g.current = null, I.current = -1;
    const E = je(d, ee), y = E != null ? ae(E) : null;
    if (y != null) {
      const B = N.current;
      m.commit(p.current ?? y.value), R(p.current ?? y.value, Tt(B, d));
    }
    "pointerType" in d && ((C = O.current) != null && C.hasPointerCapture(d.pointerId)) && ((v = O.current) == null || v.releasePointerCapture(d.pointerId)), ee.current = null, j.current = null, U();
  }
  const Ne = T((d) => {
    if (u)
      return;
    const E = d.changedTouches[0];
    E != null && (ee.current = E.identifier);
    const y = je(d, ee);
    if (y != null) {
      Ee(y);
      const v = ae(y);
      if (v == null)
        return;
      L(v.thumbIndex), H(v.value, Fe(Rt, d, void 0, {
        activeThumbIndex: v.thumbIndex
      })), M.current = Array.isArray(v.value) ? v.value : [v.value], v.didSwap && L(v.thumbIndex);
    }
    Z.current = 0;
    const C = Te(O.current);
    C.addEventListener("touchmove", _, {
      passive: !0
    }), C.addEventListener("touchend", ge, {
      passive: !0
    });
  }), U = T(() => {
    const d = Te(O.current);
    d.removeEventListener("pointermove", _), d.removeEventListener("pointerup", ge), d.removeEventListener("touchmove", _), d.removeEventListener("touchend", ge), j.current = null;
  }), z = ur();
  return i.useEffect(() => {
    const d = O.current;
    return d ? (d.addEventListener("touchstart", Ne, {
      passive: !0
    }), () => {
      d.removeEventListener("touchstart", Ne), z.cancel(), U();
    }) : () => U();
  }, [U, Ne, O, z]), i.useEffect(() => {
    u && U();
  }, [u, U]), Le("div", t, {
    state: he,
    ref: [n, D, O, ce],
    props: [{
      "data-base-ui-slider-control": ue ? "" : void 0,
      onPointerDown(d) {
        const E = O.current;
        if (!E || u || d.defaultPrevented || !Ke(d.target) || // Only handle left clicks
        d.button !== 0)
          return;
        const y = je(d, ee);
        if (y != null) {
          Ee(y);
          const v = ae(y);
          if (v == null)
            return;
          Yn(J.current[v.thumbIndex], $t(Te(E))) ? d.preventDefault() : z.request(() => {
            L(v.thumbIndex);
          }), pe(!0), g.current != null || (H(v.value, Fe(Rt, d.nativeEvent, void 0, {
            activeThumbIndex: v.thumbIndex
          })), M.current = Array.isArray(v.value) ? v.value : [v.value], v.didSwap && L(v.thumbIndex));
        }
        d.nativeEvent.pointerId && E.setPointerCapture(d.nativeEvent.pointerId), Z.current = 0;
        const C = Te(O.current);
        C.addEventListener("pointermove", _, {
          passive: !0
        }), C.addEventListener("pointerup", ge, {
          once: !0
        });
      },
      tabIndex: -1
    }, s],
    stateAttributesMapping: _e
  });
});
process.env.NODE_ENV !== "production" && (en.displayName = "SliderControl");
const tn = /* @__PURE__ */ i.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    ...s
  } = t, {
    state: u
  } = Je();
  return Le("div", t, {
    state: u,
    ref: n,
    props: [{
      style: {
        position: "relative"
      }
    }, s],
    stateAttributesMapping: _e
  });
});
process.env.NODE_ENV !== "production" && (tn.displayName = "SliderTrack");
const At = {
  clip: "rect(0 0 0 0)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "fixed",
  top: 0,
  left: 0,
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
};
function dt(e, t, n) {
  return (e - t) * 100 / (n - t);
}
const Xe = "ArrowUp", Ze = "ArrowDown", Qe = "ArrowLeft", et = "ArrowRight", tt = "Home", nt = "End", fr = /* @__PURE__ */ new Set([Qe, et]), mr = /* @__PURE__ */ new Set([Xe, Ze]), pr = /* @__PURE__ */ new Set([...fr, ...mr]);
[...pr];
const hr = /* @__PURE__ */ new Set([Xe, Ze, Qe, et, tt, nt]);
let br = /* @__PURE__ */ function(e) {
  return e[e.None = 0] = "None", e[e.GuessFromOrder = 1] = "GuessFromOrder", e;
}({});
function gr(e = {}) {
  const {
    label: t,
    metadata: n,
    textRef: r,
    indexGuessBehavior: o,
    index: s
  } = e, {
    register: u,
    unregister: l,
    subscribeMapChange: m,
    elementsRef: h,
    labelsRef: p,
    nextIndexRef: N
  } = Kn(), b = i.useRef(-1), [c, a] = i.useState(s ?? (o === br.GuessFromOrder ? () => {
    if (b.current === -1) {
      const f = N.current;
      N.current += 1, b.current = f;
    }
    return b.current;
  } : -1)), R = i.useRef(null), w = i.useCallback((f) => {
    var g;
    if (R.current = f, c !== -1 && f !== null && (h.current[c] = f, p)) {
      const I = t !== void 0;
      p.current[c] = I ? t : ((g = r == null ? void 0 : r.current) == null ? void 0 : g.textContent) ?? f.textContent;
    }
  }, [c, h, p, t, r]);
  return W(() => {
    if (s != null)
      return;
    const f = R.current;
    if (f)
      return u(f, n), () => {
        l(f);
      };
  }, [s, u, l, n]), W(() => {
    if (s == null)
      return m((f) => {
        var I;
        const g = R.current ? (I = f.get(R.current)) == null ? void 0 : I.index : null;
        g != null && a(g);
      });
  }, [s, m, a]), i.useMemo(() => ({
    ref: w,
    index: c
  }), [c, w]);
}
function yr(e = {}) {
  const {
    id: t,
    implicit: n = !1,
    controlRef: r
  } = e, {
    controlId: o,
    setControlId: s
  } = jt(), u = He(t);
  return W(() => {
    if (!(!n && !t || s === fe)) {
      if (n) {
        const l = r == null ? void 0 : r.current;
        Ke(l) && l.closest("label") != null ? s(t ?? null) : s(o ?? u);
      } else
        t && s(t);
      return () => {
        t && s(void 0);
      };
    }
  }, [t, r, o, s, n, u]), o ?? u;
}
let vr = /* @__PURE__ */ function(e) {
  return e.index = "data-index", e.dragging = "data-dragging", e.orientation = "data-orientation", e.disabled = "data-disabled", e.readonly = "data-readonly", e.required = "data-required", e.valid = "data-valid", e.invalid = "data-invalid", e.touched = "data-touched", e.dirty = "data-dirty", e.focused = "data-focused", e;
}({});
const Ir = '!function(){const t=document.currentScript?.parentElement;if(!t)return;const e=t.closest("[data-base-ui-slider-control]");if(!e)return;const r=e.querySelector("[data-base-ui-slider-indicator]"),i=e.getBoundingClientRect(),n="vertical"===e.getAttribute("data-orientation")?"height":"width",o=e.querySelectorAll(\'input[type="range"]\'),l=o.length>1,s=o.length-1;let a=null,u=null;for(let t=0;t<o.length;t+=1){const e=o[t],y=parseFloat(e.getAttribute("value")??"");if(Number.isNaN(y))return;const c=e.parentElement;if(!c)return;const p=parseFloat(e.getAttribute("max")??"100"),g=parseFloat(e.getAttribute("min")??"0"),b=c?.getBoundingClientRect(),d=i[n]-b[n],m=100*(y-g)/(p-g),v=(b[n]/2+d*m/100)/i[n]*100;c.style.setProperty("--position",`${v}%`),Number.isFinite(v)&&(c.style.removeProperty("visibility"),r&&(0===t?(a=v,r.style.setProperty("--start-position",`${v}%`),l||r.style.removeProperty("visibility")):t===s&&(u=v-(a??0),r.style.setProperty("--end-position",`${v}%`),r.style.setProperty("--relative-size",`${u}%`),r.style.removeProperty("visibility"))))}}();', nn = "PageUp", rn = "PageDown", Er = /* @__PURE__ */ new Set([Xe, Ze, Qe, et, tt, nt, nn, rn]);
function Rr(e, t, n, r) {
  if (!(t < 0))
    return e.length === 2 ? t === 0 ? `${Ge(e[t], r, n)} start range` : `${Ge(e[t], r, n)} end range` : n ? Ge(e[t], r, n) : void 0;
}
function Ve(e, t, n, r, o) {
  return n === 1 ? Math.min(e + t, o) : Math.max(e - t, r);
}
const ft = /* @__PURE__ */ i.forwardRef(function(t, n) {
  const {
    render: r,
    children: o,
    className: s,
    "aria-describedby": u,
    "aria-label": l,
    "aria-labelledby": m,
    disabled: h = !1,
    getAriaLabel: p,
    getAriaValueText: N,
    id: b,
    index: c,
    inputRef: a,
    onBlur: R,
    onFocus: w,
    onKeyDown: f,
    tabIndex: g,
    ...I
  } = t, j = He(b), {
    active: D,
    lastUsedThumbIndex: ue,
    controlRef: we,
    disabled: pe,
    validation: H,
    formatOptionsRef: he,
    handleInputChange: Y,
    inset: K,
    labelId: J,
    largeStep: A,
    locale: X,
    max: F,
    min: x,
    minStepsBetweenValues: O,
    name: $,
    orientation: ce,
    pressedInputRef: ee,
    pressedThumbCenterOffsetRef: Z,
    pressedThumbIndexRef: be,
    renderBeforeHydration: M,
    setActive: Se,
    setIndicatorPosition: ae,
    state: Ee,
    step: L,
    values: _
  } = Je(), ge = Xt(), Ne = h || pe, U = _.length > 1, z = ce === "vertical", le = ge === "rtl", {
    setTouched: d,
    setFocused: E,
    validationMode: y
  } = ht(), C = i.useRef(null), v = i.useRef(null), B = He(), ye = yr(), te = U ? B : ye, Re = i.useMemo(() => ({
    inputId: te
  }), [te]), {
    ref: Oe,
    index: xe
  } = gr({
    metadata: Re
  }), P = U ? c ?? xe : 0, Pe = P === _.length - 1, ne = _[P], re = dt(ne, x, F), [Q, Ae] = i.useState(!1), [se, rt] = i.useState();
  gt(() => Ae(!0));
  const Be = ue >= 0 && ue < _.length ? ue : -1, S = T(() => {
    const V = we.current, k = C.current;
    if (!V || !k)
      return;
    const q = k.getBoundingClientRect(), Ue = V.getBoundingClientRect(), ze = z ? "height" : "width", sn = Ue[ze] - q[ze], ot = (q[ze] / 2 + sn * re / 100) / Ue[ze] * 100;
    rt(ot), P === 0 ? ae((st) => [ot, st[1]]) : Pe && ae((st) => [st[0], ot]);
  });
  W(() => {
    K && queueMicrotask(S);
  }, [S, K]), W(() => {
    K && S();
  }, [S, K, re]);
  const oe = i.useCallback(() => {
    const V = z ? "bottom" : "insetInlineStart", k = z ? "left" : "top";
    let q;
    return U ? D === P ? q = 2 : Be === P && (q = 1) : D === P && (q = 1), K ? {
      "--position": `${se}%`,
      visibility: M && !Q || se === void 0 ? "hidden" : void 0,
      position: "absolute",
      [V]: "var(--position)",
      [k]: "50%",
      translate: `${(z || !le ? -1 : 1) * 50}% ${(z ? 1 : -1) * 50}%`,
      zIndex: q
    } : Number.isFinite(re) ? {
      position: "absolute",
      [V]: `${re}%`,
      [k]: "50%",
      translate: `${(z || !le ? -1 : 1) * 50}% ${(z ? 1 : -1) * 50}%`,
      zIndex: q
    } : At;
  }, [D, P, K, Q, se, U, M, le, Be, re, z]);
  let de;
  ce === "vertical" && (de = le ? "vertical-rl" : "vertical-lr");
  const Ce = kt({
    "aria-label": typeof p == "function" ? p(P) : l,
    "aria-labelledby": m ?? J,
    "aria-describedby": u,
    "aria-orientation": ce,
    "aria-valuenow": ne,
    "aria-valuetext": typeof N == "function" ? N(Ge(ne, X, he.current ?? void 0), ne, P) : Rr(_, P, he.current ?? void 0, X),
    disabled: Ne,
    id: te,
    max: F,
    min: x,
    name: $,
    onChange(V) {
      Y(V.target.valueAsNumber, P, V);
    },
    onFocus() {
      Se(P), E(!0);
    },
    onBlur() {
      C.current && (Se(-1), d(!0), E(!1), y === "onBlur" && H.commit(Kt(ne, P, x, F, U, _)));
    },
    onKeyDown(V) {
      if (!Er.has(V.key))
        return;
      hr.has(V.key) && V.stopPropagation();
      let k = null;
      const q = Qt(ne, L, x);
      switch (V.key) {
        case Xe:
          k = Ve(q, V.shiftKey ? A : L, 1, x, F);
          break;
        case et:
          k = Ve(q, V.shiftKey ? A : L, le ? -1 : 1, x, F);
          break;
        case Ze:
          k = Ve(q, V.shiftKey ? A : L, -1, x, F);
          break;
        case Qe:
          k = Ve(q, V.shiftKey ? A : L, le ? 1 : -1, x, F);
          break;
        case nn:
          k = Ve(q, A, 1, x, F);
          break;
        case rn:
          k = Ve(q, A, -1, x, F);
          break;
        case nt:
          k = F, U && (k = Number.isFinite(_[P + 1]) ? _[P + 1] - L * O : F);
          break;
        case tt:
          k = x, U && (k = Number.isFinite(_[P - 1]) ? _[P - 1] + L * O : x);
          break;
      }
      k !== null && (Y(k, P, V), V.preventDefault());
    },
    step: L,
    style: {
      ...At,
      // So that VoiceOver's focus indicator matches the thumb's dimensions
      width: "100%",
      height: "100%",
      writingMode: de
    },
    tabIndex: g ?? void 0,
    type: "range",
    value: ne ?? ""
  }, H.getInputValidationProps), $e = ct(v, H.inputRef, a);
  return Le("div", t, {
    state: Ee,
    ref: [n, Oe, C],
    props: [{
      [vr.index]: P,
      children: /* @__PURE__ */ Ye(i.Fragment, {
        children: [o, /* @__PURE__ */ ie("input", {
          ref: $e,
          ...Ce
        }), K && !Q && M && // this must be rendered with the last thumb to ensure all
        // preceding thumbs are already rendered in the DOM
        Pe && /* @__PURE__ */ ie("script", {
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML: {
            __html: Ir
          },
          suppressHydrationWarning: !0
        })]
      }),
      id: j,
      onBlur: R,
      onFocus: w,
      onPointerDown(V) {
        if (be.current = P, C.current != null) {
          const k = ce === "horizontal" ? "x" : "y", q = Zt(C.current), Ue = (ce === "horizontal" ? V.clientX : V.clientY) - q[k];
          Z.current = Ue;
        }
        v.current != null && ee.current !== v.current && (ee.current = v.current);
      },
      style: oe(),
      suppressHydrationWarning: M || void 0,
      tabIndex: -1
    }, I],
    stateAttributesMapping: _e
  });
});
process.env.NODE_ENV !== "production" && (ft.displayName = "SliderThumb");
function Nr(e, t, n, r, o, s) {
  const u = n === void 0 || t && r === void 0 ? "hidden" : void 0, l = e ? "bottom" : "insetInlineStart", m = e ? "height" : "width", p = {
    visibility: o && !s ? "hidden" : u,
    position: e ? "absolute" : "relative",
    [e ? "width" : "height"]: "inherit"
  };
  return p["--start-position"] = `${n ?? 0}%`, t ? (p["--relative-size"] = `${(r ?? 0) - (n ?? 0)}%`, p[l] = "var(--start-position)", p[m] = "var(--relative-size)", p) : (p[l] = 0, p[m] = "var(--start-position)", p);
}
function Cr(e, t, n, r) {
  const o = e ? "bottom" : "insetInlineStart", s = e ? "height" : "width", l = {
    position: e ? "absolute" : "relative",
    [e ? "width" : "height"]: "inherit"
  };
  if (!t)
    return l[o] = 0, l[s] = `${n}%`, l;
  const m = r - n;
  return l[o] = `${n}%`, l[s] = `${m}%`, l;
}
const on = /* @__PURE__ */ i.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    ...s
  } = t, {
    indicatorPosition: u,
    inset: l,
    max: m,
    min: h,
    orientation: p,
    renderBeforeHydration: N,
    state: b,
    values: c
  } = Je(), [a, R] = i.useState(!1);
  gt(() => R(!0));
  const w = p === "vertical", f = c.length > 1, g = l ? Nr(w, f, u[0], u[1], N, a) : Cr(w, f, dt(c[0], h, m), dt(c[c.length - 1], h, m));
  return Le("div", t, {
    state: b,
    ref: n,
    props: [{
      "data-base-ui-slider-indicator": N ? "" : void 0,
      style: g,
      suppressHydrationWarning: N || void 0
    }, s],
    stateAttributesMapping: _e
  });
});
process.env.NODE_ENV !== "production" && (on.displayName = "SliderIndicator");
function wr(e) {
  return Array.isArray(e) && e.length === 2 ? [e[0], e[1]] : null;
}
const Sr = G.object({
  variants: G.custom().optional(),
  min: G.number(),
  max: G.number(),
  value: G.tuple([G.number(), G.number()]),
  onValueChange: G.custom().optional(),
  onValueCommitted: G.custom().optional(),
  step: G.number().optional(),
  minStepsBetweenValues: G.number().optional(),
  disabled: G.boolean().optional(),
  formatValue: G.custom().optional(),
  minLabel: G.string().optional(),
  maxLabel: G.string().optional()
}), kr = an(
  "Range",
  ln(
    Sr,
    ({
      variants: e,
      min: t,
      max: n,
      value: r,
      onValueChange: o,
      onValueCommitted: s,
      step: u,
      minStepsBetweenValues: l,
      disabled: m,
      formatValue: h = (b) => String(b),
      minLabel: p = "Minimum value",
      maxLabel: N = "Maximum value"
    }) => {
      const b = dn.styles(e), c = (R) => {
        const w = wr(R);
        w && (o == null || o(w));
      }, a = () => {
        s == null || s(r);
      };
      return /* @__PURE__ */ Ye(
        Ht,
        {
          className: b.base,
          min: t,
          max: n,
          value: r,
          step: u,
          minStepsBetweenValues: l,
          disabled: m,
          onValueChange: c,
          children: [
            /* @__PURE__ */ ie("div", { className: b.selectedRange, children: `${h(r[0])} – ${h(r[1])}` }),
            /* @__PURE__ */ ie(
              en,
              {
                className: b.control,
                "data-vaul-no-drag": !0,
                onPointerUp: a,
                onKeyUp: (R) => {
                  (R.key.startsWith("Arrow") || R.key === "Home" || R.key === "End") && a();
                },
                children: /* @__PURE__ */ Ye(tn, { className: b.track, children: [
                  /* @__PURE__ */ ie(on, { className: b.indicator }),
                  /* @__PURE__ */ ie(ft, { "aria-label": p, className: b.thumb }),
                  /* @__PURE__ */ ie(ft, { "aria-label": N, className: b.thumb })
                ] })
              }
            ),
            /* @__PURE__ */ Ye("div", { className: b.bounds, children: [
              /* @__PURE__ */ ie("span", { children: h(t) }),
              /* @__PURE__ */ ie("span", { children: h(n) })
            ] })
          ]
        }
      );
    }
  )
);
export {
  kr as Range,
  Sr as rangeSchema
};
//# sourceMappingURL=index.es.js.map
